import { capitalize as capitalizeLodash } from 'lodash';

export const capitalize = (str: string, everyWord?: boolean) => {
  if (everyWord) {
    return str
      .split(' ')
      .map(word => capitalizeLodash(word))
      .join(' ');
  }

  return capitalizeLodash(str);
};

export const capitalizeAll = (str: string) => {
  return capitalize(str, true);
};
